<template>
    <header>
        <router-link :to="{name: 'home-with-lang', params:{ lang }}" class="btn-icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 65"><path fill-rule="evenodd" d="M55.07 61.72c-.26 1.11-5.36 4.04-12.45 1.77-3.32-1.07-1.21-11.6-2.7-13.5-1.16-1.48-11.14-3.17-14.39.1-2.03 2.04.06 12.43-4.3 13.7-6.45 1.87-7.8.24-8.79-.05-1.89-.54-4.05-.8-3.86-12.14.18-11.3 1.3-19.76 1.3-19.76s-4.36 3.08-7.34 2.54c-2.97-.54-4.34-2.61 1.6-12.33C10.09 12.31 30.62-1.94 34.41.22c5.21 2.97 15.44 8.87 25.27 22.58 4.65 6.48 6.39 14.69-1.81 11.02-3.74-1.68-3.64-1.96-3.64-1.96s2.22 24.04.84 29.87v-.01Z" clip-rule="evenodd"/></svg>
            <span class="sr-only">Accueil</span>
        </router-link>
    </header>



    <nav role="navigation" class="big-buttons">
        <router-link :to="{name: 'profiles', params:{ lang }}" class="btn-image">
            <h2 class="btn-image-title">{{ copydeck.parents_zone.btn_profiles[lang] }}</h2>
            <img src="/images/bg-profils.jpg" width="348" height="398" alt=""/>
            <span class="btn-primary">{{ copydeck.parents_zone.btn_choose[lang] }}</span>
        </router-link>
        <router-link :to="{name: 'music', params:{ lang }}" class="btn-image">
            <h2 class="btn-image-title">{{ copydeck.parents_zone.btn_playlist[lang] }}</h2>
            <img src="/images/bg-music.jpg" width="348" height="398" alt=""/>
            <span class="btn-primary">{{ copydeck.parents_zone.btn_choose[lang] }}</span>
        </router-link>
    </nav>

    <footer v-if="!profileModalOpen && !isLoading">
        <nav role="navigation" class="footer-nav">
            <a v-if="lang === 'en'" href="/fr" class="btn-secondary">Français</a>
            <a v-if="lang === 'fr'" href="/en" class="btn-secondary">English</a>
            <router-link :to="{name: 'credits', params:{ lang }}" class="btn-secondary"> {{ copydeck.home.btn_credits[lang] }}</router-link>
        </nav>
    </footer>
</template>

<script>
    export default {
        name: "ParentsArea"
    }
</script>

<script setup>

    import { useRouter } from "vue-router";
    import { useMainStore }     from "../stores/main";
    import { storeToRefs }        from "pinia";

    const router = useRouter();
    let store = useMainStore();
    const { lang, copydeck } = storeToRefs(store);

</script>
